import React from 'react'
import SubHeader from '../../layout/components/SubHeader'

function ApptHeader({totalAppointment,confirmedAppointment}) {
  return (
    <>
      <SubHeader title="Appointments" description={"Total : "+totalAppointment+" | Confirmed : "+confirmedAppointment}/>
    </>
  )
}

export default ApptHeader